import apk from "./contrall-2.28(107)-release.apk";

export default apk;
